"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";
import AppImage from "@/components/ui/AppImage";

export default function AboutHero() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.querySelectorAll(".hero-reveal").forEach((item, i) => {
      (item as HTMLElement).style.animationDelay = `${0.1 + i * 0.12}s`;
      item.classList.add("animate-in");
    });
  }, []);

  return (
    <section ref={ref} className="relative pt-32 pb-20 bg-[#0C1B33] overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `radial-gradient(ellipse 70% 50% at 30% 60%, rgba(201,168,76,0.1) 0%, transparent 70%)`
        }} />
      
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(rgba(245,240,232,1) 1px, transparent 1px), linear-gradient(90deg, rgba(245,240,232,1) 1px, transparent 1px)`,
          backgroundSize: "80px 80px"
        }} />
      

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Left */}
          <div className="lg:col-span-6 space-y-8">
            <div className="hero-reveal opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[rgba(201,168,76,0.3)] bg-[rgba(201,168,76,0.06)]">
              <span className="text-[11px] font-display font-600 uppercase tracking-[0.18em] text-gold">
                About StanDave LLC
              </span>
            </div>

            <h1 className="hero-reveal opacity-0 font-display font-700 leading-[1.05] tracking-tight">
              <span className="block text-5xl md:text-6xl text-cream">
                Operational
              </span>
              <span className="block text-5xl md:text-6xl text-shimmer mt-1">
                Excellence.
              </span>
              <span className="block text-3xl md:text-4xl text-cream/60 font-300 mt-2">
                Global Impact.
              </span>
            </h1>

            <p className="hero-reveal opacity-0 text-[19px] font-body text-cream/60 leading-relaxed max-w-xl">
              StanDave LLC is a global operations and consulting firm specializing in asset management, supply chain optimization, logistics coordination, and strategic business advisory services.
            </p>

            <div className="hero-reveal opacity-0 flex gap-4">
              <Link
                href="/homepage#contact"
                className="btn-primary px-8 py-4 text-sm rounded-sm font-display">
                
                Work With Us
              </Link>
              <Link
                href="/homepage#services"
                className="btn-outline px-8 py-4 text-sm rounded-sm font-display">
                
                Our Services
              </Link>
            </div>
          </div>

          {/* Right: Image with overlay */}
          <div className="lg:col-span-6 relative hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden h-[460px]">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1bb48a385-1772180361195.png"
                alt="Modern corporate office building with glass facade representing global business operations"
                fill
                className="object-cover" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-[#0C1B33] via-transparent to-transparent opacity-80" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0C1B33] via-transparent to-transparent opacity-40" />

              {/* Overlay stat */}
              <div className="absolute bottom-8 left-8 glass-card rounded-xl p-5">
                <div className="text-[10px] font-display uppercase tracking-widest text-muted mb-1">
                  Founded
                </div>
                <div className="text-2xl font-display font-700 text-gold">2012</div>
                <div className="text-[12px] font-body text-cream/60 mt-0.5">
                  12+ years of excellence
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}